module.exports = __webpack_public_path__ + "img/hxy.30398ff7.png";